import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=633cdb6d&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=633cdb6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cdb6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633cdb6d')) {
      api.createRecord('633cdb6d', component.options)
    } else {
      api.reload('633cdb6d', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=633cdb6d&scoped=true&", function () {
      api.rerender('633cdb6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yuoqbQJGxuRd/JS/teamMember.vue"
export default component.exports